
import { useRef } from 'react';
import emailjs from '@emailjs/browser';

function Contact() {
    const form = useRef();

    function submitContact(event) {
        event.preventDefault();
        emailjs
        .sendForm('service_r5l9b7c', 'template_ykeiql4', form.current, {
            publicKey: 'iKWXMmArwngHrpt-W',
        })
        .then(
            () => {
                form.current.reset();
                alert("Successfully submitted form!");
            },
            (error) => {
                form.current.reset();
                alert("Failed to submit form. Try again in a few minutes.")
            },
        );
    }

    return (
        <div>
            <div className="container-contact">
                <form ref={form} onSubmit={submitContact}>
                    <label>First Name</label>
                    <input type="text" id="fname" name="firstname" placeholder="Your name.."/>

                    <label>Last Name</label>
                    <input type="text" id="lname" name="lastname" placeholder="Your last name.."/>

                    <label>Email</label>
                    <input type="text" id="email" name="email" placeholder="Your email.."/>

                    <label>Phone</label>
                    <input type="text" id="phone" name="phone" placeholder="Your phone number.."/>

                    <label>Request Type</label>
                    <select id="requesttype" name="requesttype">
                        <option value="Request a Service">Request a Service</option>
                        <option value="Get an Estimate">Get an Estimate</option>
                    </select>

                    <label>Description</label>
                    <textarea id="subject" name="desc" placeholder="Write something.." style={{height:"200px"}}></textarea>

                    <input type="submit" value="Submit"/>
                </form>
            </div>
        </div>
    )
}
export default Contact;